var $287e14571e3084c4$exports = {};
$287e14571e3084c4$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selector de color`,
    "colorSwatch": `muestra de color`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Regulador 2D`
};


export {$287e14571e3084c4$exports as default};
//# sourceMappingURL=es-ES.mjs.map
